import { Component, OnInit,Input,EventEmitter,Output} from '@angular/core';
import{ContentManagementService} from '../../../Services/content-management/content-management.service';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { ContentStatusModel } from 'src/app/Models/ContentStatus';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoice } from 'src/app/Validators/Validators';
import { ToastrService } from "ngx-toastr";
import { DomSanitizer } from '@angular/platform-browser';
import { ConstantVars } from 'src/app/utils/constants/constants';

@Component({
  selector: 'app-content-for-review',
  templateUrl: './content-for-review.component.html',
  styleUrls: ['./content-for-review.component.css'],
})
export class ContentForReviewComponent implements OnInit {
  InsertContentStatus: ContentStatusModel;
  AddContentStatusform: FormGroup;
  @Input() subjectById: any;
  @Input() ScreenName1: string;
  @Input() Contentstatus: any;
  @Input() Contenttext: any;
  @Input() selectedContentById: any;
  @Output() ReturnContentreviewclose: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() returnreviewpopup: EventEmitter<any> = new EventEmitter<any>();
  @Output() CloseandRefreshlist: EventEmitter<any> = new EventEmitter<any>();
  Filename: string;
  FileType: any;
  urlSafe: any;
  prev_url: any;
  assetURL: string;
  RTEFlag: string = 'Submit for review';
  QuestionBodyget: string;

  constructor(
    private sanitizer: DomSanitizer,
    public service: ContentManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {
    this.RTEFlag = 'Submit for review';
  }
  InitializeForm() {
    this.AddContentStatusform = this.fb.group({
      Study_Material_Name: [''],
      Comment_Text: [''],
    });
  }
  ngOnInit() {
    this.InitializeForm();
    this.getCode();
    this.Descriptioncount();
    console.log(this.selectedContentById, 'selectedContentById');
    console.log(this.Contentstatus, 'Contentstatus');
    this.getBreadcrumbDetails();
    this.GetContentStatusID(this.selectedContentById.Study_Material_Status_Id);
    this.AddContentStatusform.controls['Study_Material_Name'].setValue(
      this.selectedContentById.Study_Material_Name
    );
    this.AddContentStatusform.controls['Comment_Text'].setValue(
      this.Contenttext
    );
    this.QuestionBodyget = this.Contenttext;

    this.RTEFlag = 'Submit for review';
  }

  ContentStatusList: any;
  Content: any;
  GetContentStatusID(data: any) {
    this.service
      .GetContentStatusByID({
        Study_Material_Status_Id: data,
        IncludeReasonNotSelectedInd: 'N',
      })
      .subscribe(
        (i: any) => {
          this.Content = i;
          this.ContentStatusList = this.Content.StudyMaterialByID;

          if (this.ContentStatusList.length &&this.ContentStatusList[0].Study_Material_Status_ID != null) {
            this.AddContentStatusform.controls['Study_Material_Name'].setValue(
              this.selectedContentById.Study_Material_Name
            );
          }

          // }).catch((e:any)=>{
          //   this.ContentStatusList=null;
          // });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getcodes: any;
  TableName: any;
  getCode() {
    if (this.Contentstatus == 'Defer') {
      this.TableName = 'STUDY_MATERIAL_DEFER_REASON_TYPE';
    } else if (this.Contentstatus == 'Rework') {
      this.TableName = 'STUDY_MATERIAL_REWORK_REASON_TYPE';
    } else if (this.Contentstatus == 'Rejected') {
      this.TableName = 'STUDY_MATERIAL_REJECTED_REASON_TYPE';
    } else {
      this.TableName = this.Contentstatus;
    }

    this.service.GetCode({ Tablename: this.TableName }).subscribe(
      (i: any) => {
        this.getcodes = i;
        if (this.getcodes != null) {
          this.getcodes.map((obj: { checkedflag: boolean }) => {
            obj.checkedflag = false;
            return obj;
          });
        }

        // }).catch((e:any)=>{
        //   this.getcodes=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save_submitted: boolean = false;
  QuestionQuestionResponse: any;
  Modalclose: boolean;
  ReviewReasons: any;
  AddContentStatus() {
    if (this.Contentstatus !== 'Submitted') {
      this.checkboxvalidation();
    }
    if (!this.error1.isError) {
      this.InsertContentStatus = this.AddContentStatusform.value;
      //this.InsertContentStatus.Study_Material_Status_ID=this.ContentStatusList[0].Study_Material_Status_ID;
      this.InsertContentStatus.Study_Material_Status_Type_Code =
        this.Contentstatus;
      this.InsertContentStatus.Study_Material_Status_ID =
        this.selectedContentById.Study_Material_Status_ID;
      // if(this.AddContentStatusform.controls['Comment_Text'].value==null){
      //   this.InsertContentStatus.Comment_Text=''
      // }
      this.InsertContentStatus.Study_Material_ID =
        this.selectedContentById.Study_Material_Id;

      if (this.getcodes != null) {
        let UDTReason: any[] = [];
        this.ReviewReasons = this.getcodes.filter(
          (item: { checkedflag: boolean }) => item.checkedflag == true
        );
        this.ReviewReasons.forEach((element: { Code: any }) => {
          let list: any = {};
          list['ReviewActionReasonTypeCode'] = element.Code;
          UDTReason.push(list);
        });
        this.InsertContentStatus.UDTStudyMaterialReviewActionReason = UDTReason;
      }
      //  else{
      //   let UDTReason = [];
      //   let list: any = {};
      //   list["ReviewActionReasonTypeCode"] = 'DifficultyLevel';
      //   UDTReason.push(list);
      //   this.InsertQuestionStatus.UDTQuestionReviewActionReason=UDTReason;
      //  }
      this.service
        .CreateOrModifyStudyMaterialStatus(this.InsertContentStatus)
        .subscribe(
          (i: any) => {
            this.QuestionQuestionResponse = i;
            if (this.QuestionQuestionResponse.Message == 'Success') {
              this.toastr.success(
                'Study Material Status Added Successfully',
                'Success  ',
                {
                  timeOut: ConstantVars.ToastSucessTimeout,
                }
              );
              this.save_submitted = false;
              // if(this.QuestionQuestionResponse.Value!=null&&this.QuestionQuestionResponse.Value!=""){
              //   this.getQuestionByID(this.AddQuestionResponse.Value);
              // }
              // else{
              //   this.getQuestionByID(this.AddQuestionform.controls['Question_ID'].value);
              // }
              //if(this.EditQuestionFlag){

              // this.Questionreviewclose.emit(this.Modalclose);
              //     this.CloseEditQuestion.emit(this.Modalclose);
              this.ReturnContentreviewclose.emit(1);
              this.returnreviewpopup.emit(1);
              this.CloseandRefreshlist.emit(this.Modalclose);

              //}
              //
            } else {
              this.toastr.error(this.QuestionQuestionResponse.Message);
            }
            //  }).catch((e:any)=>{
            //    this.QuestionQuestionResponse=e;
            //    this.toastr.error(this.QuestionQuestionResponse.statusText);
            //    this.save_submitted=false;

            //  }
            //  )
          },
          (error) => {
            this.QuestionQuestionResponse = error;
            this.toastr.error(this.QuestionQuestionResponse.Message);
            this.save_submitted = false;
            console.log(error);
          }
        );
    }
  }

  Checkvalue(data: any) {
    for (let item of this.getcodes) {
      if (item.Code == data.Code) {
        if (item.checkedflag) {
          item.checkedflag = false;
        } else {
          item.checkedflag = true;
        }
      }
    }
    this.checkboxvalidation();
  }

  Checkevent(data: any) {
    this.eventCheck(data.target);
  }
  eventCheck(data: any) {
    if (this.getcodes != null) {
      for (let item of this.getcodes) {
        if (item.Code == data.value) {
          if (item.checkedflag) {
            item.checkedflag = false;
          } else {
            item.checkedflag = true;
          }
        }
      }
      this.checkboxvalidation();
    }
  }

  error1: any = { isError: false, errorMessage: '' };
  check: boolean = false;
  checkboxvalidation(): void {
    if (this.getcodes?.length) {
      const isAnyChecked = this.getcodes.some((item: any) => item.checkedflag);

      this.check = isAnyChecked;

      this.error1 = isAnyChecked
        ? { isError: false, errorMessage: '' }
        : { isError: true, errorMessage: 'Select at least one Reason' };
    }
  }

  Breadcrumblist: any;
  Breadcrumb: string;
  getBreadcrumbDetails() {
    //  this.service.getBreadcrumbDetails({ 'ID': this.subjectById.Subject_Id }).subscribe((i: any) => {
    //    this.Breadcrumblist = i;

    // }, error => {  console.log(error) }
    // );

    this.service
      .getBreadcrumb({
        ID: this.selectedContentById.Study_Unit_Id,
        Screenname: 'CONTENT_MANAGEMENT',
      })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          this.Breadcrumb = this.Breadcrumblist.Data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  Cancel() {
    this.ReturnContentreviewclose.emit(1);
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  Descriptioncount() {
    this.DescriptionMaxlength = 4000;
    if (
      this.AddContentStatusform.controls.Comment_Text.value != '' &&
      this.AddContentStatusform.controls.Comment_Text.value != null
    ) {
      if (this.AddContentStatusform.controls.Comment_Text.value.length > 0) {
        this.Descriptionvaluelength =
          this.AddContentStatusform.controls.Comment_Text.value.length;
      } else {
        this.Descriptionvaluelength = 0;
      }
    } else {
      this.Descriptionvaluelength = 0;
    }
  }

  comments: string;
  GetCommentboxContent1(data: any) {
    this.comments = data;
    //if(this.QuestionBodyContent!=null)

    this.AddContentStatusform.controls['Comment_Text'].setValue(this.comments);
  }
}
